import { useLocation, useNavigation } from "react-router";
import { PropsWithChildren } from "react";
import HomeFooter from "@/components/layouts/HomeFooter";
import AppNavbar from "@/components/layouts/AppNavbar";
import AppBreadcrumbs from "@/components/layouts/AppBreadcrumbs";
import DelegationBanner from "@/components/delegation/DelegationBanner";
import { EFT_BASE_PATH } from "@/features/cle-compliance/constants/routes";
import { isSelskabsblankettenRoute } from "@/lib/appNavigation";

const isEfteruddannelseRoute = (pathname: string) =>
  pathname === EFT_BASE_PATH || pathname.startsWith(`${EFT_BASE_PATH}/`);

export default function AppShellContent({ children }: PropsWithChildren) {
  const navigation = useNavigation();
  const { pathname } = useLocation();
  const useCleComplianceChrome = isEfteruddannelseRoute(pathname);
  const showAppBreadcrumbs =
    !useCleComplianceChrome && !isSelskabsblankettenRoute(pathname);

  return (
    <div
      className={`d-flex flex-column min-vh-100 ${
        navigation.state === "loading" ? " loading" : ""
      }`}
    >
      {!useCleComplianceChrome ? <AppNavbar /> : null}
      {!useCleComplianceChrome ? <DelegationBanner /> : null}
      {showAppBreadcrumbs ? <AppBreadcrumbs /> : null}
      {children}
      {!useCleComplianceChrome ? <HomeFooter /> : null}
    </div>
  );
}
